<template >
  <div class="m-section">
    {{title}}
    <span v-if="!$slots.default" class="m-section-subTitle">{{ subTitle }}</span>
    <slot v-else></slot>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
  },
}
</script>
<style lang='scss' scoped>
.m-section {
  margin: 30px 0 10px 0;
  font-weight: bold;
  color: var(--theme);
  font-size: 16px;
  border-bottom: solid 2px #efefef;
  padding-bottom: 10px;
  display: flex;
  justify-content: space-between;
  &-subTitle {
    background-color: #fff;
    color: red;
  }
}
</style>
